import { render, staticRenderFns } from "./new-business-form.vue?vue&type=template&id=c737217e&scoped=true&"
import script from "./new-business-form.vue?vue&type=script&lang=js&"
export * from "./new-business-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c737217e",
  null
  
)

export default component.exports